export default {
  methods: {
    isEnglish: function () {
      const language = this.$route.params.lang
      if (language === 'en') {
        return true
      } else {
        return false
      }
    },
    isKorean: function () {
      const language = this.$route.params.lang
      if (language === 'ko') {
        return true
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/mixins/i18n.js